export const TimeUtil = {
    delay(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    },
}